module.exports = function getResource(label, vars = []) {
    const resources = { error: 'Erreur' };

    return resources[label];
};
